<ng-select 
  [items]="conditions" 
  [clearable]="true" 
  [searchFn]="customSearchFn" 
  bindLabel="contractName" 
  bindValue="contractId"
  class="dropdown-credit truncate-option" 
  [(ngModel)]="contractSelect" 
  placeholder="Selecione o Contrato"
  (change)="selectContract($event)" 
  [hideSelected]="true" 
  notFoundText="Não encontrado">

  <ng-template ng-option-tmp let-item="item">
    <span class="truncate-text">
      {{ item.contractId }} ({{ item.contractName }})
    </span>
  </ng-template>

  <ng-template ng-label-tmp let-item="item">
    <span class="truncate-text">
      {{ item.contractId }} ({{ item.contractName }})
    </span>
  </ng-template>
</ng-select>